import React from "react";
import { useParams } from "react-router-dom";

interface PartnerFormHeaderProps {
	title: string;
	description?: string;
}

const PartnerFormHeader: React.FC<PartnerFormHeaderProps> = ({
	title,
	description,
}) => {
	return (
		<div className='mb-8'>
			<div className='flex items-center gap-2 mb-2'></div>
			<h1 className='text-3xl font-bold text-gray-900 mb-2'>{title}</h1>
			<p className='text-gray-600'>{description}</p>
		</div>
	);
};

export default PartnerFormHeader;
